export const formatDateToDotSeparated = (date: string) => {
  return date.slice(0, 10).replace(/-/g, ".");
};
